import styled from "styled-components";

const StyledCheckbox = styled.input`
  accent-color: ${(props) => props.theme.colorPrimary};
`;

const TableCheckbox = ({ ...prop }) => {
  return <StyledCheckbox type={"checkbox"} {...prop} />;
};

export default TableCheckbox;
